import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getLogin ={
    getUserLogin(params) {
        return axios.post(`/mobile/power/user_login`,qs.stringify(params));
    },
    getUserResgiter(params) {
        return axios.post(`/mobile/power/user_reg`,qs.stringify(params));
    },
    changePssword(params) {
        return axios.post(`/mobile/power/change_password`, qs.stringify(params));
    },
    is_have_user(params) {
        return axios.post(`/mobile/power/is_have_user`, qs.stringify(params));
    },
    sendCode(params) {
        return axios.post(`/mobile/power/sendcode`, qs.stringify(params));
    },
    sendResetPasswordCode(params) {
        return axios.post(`/mobile/power/sendcode`, qs.stringify(params));
    },
    
}
export default getLogin;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/login.js